export default function TimeIcon() {
  return (
    <svg
      width="16"
      height="19"
      viewBox="0 0 16 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 11L11.0936 7.90641M6.125 1.625H9.875M14.875 11C14.875 14.797 11.797 17.875 8 17.875C4.20304 17.875 1.125 14.797 1.125 11C1.125 7.20304 4.20304 4.125 8 4.125C11.797 4.125 14.875 7.20304 14.875 11Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}
